import { Injectable } from "@angular/core";
import { EntityInterface, TableAction } from "../../model/Table";

@Injectable({
  providedIn: 'root'
})
export class RunningActions {
  private running: Map<string, Set<string>> = new Map();

  public set<Entity extends EntityInterface>(action: TableAction<Entity>, entity: Entity): void {
    if (typeof entity.id === 'undefined') { return; }
    if (!this.running.has(action.display)) {
      this.running.set(action.display, new Set());
    }
    this.running.get(action.display)?.add(entity.id);
  }
  
  public unset<Entity extends EntityInterface>(action: TableAction<Entity>, entity: Entity): void {
    if (typeof entity.id === 'undefined') { return; }
    this.running.get(action.display)?.delete(entity.id);
    if (this.running.get(action.display)?.size === 0) {
      this.running.delete(action.display);
    }
  }

  public get<Entity extends EntityInterface>(action: TableAction<Entity>, entity: Entity): boolean {
    if (typeof entity.id === 'undefined') { throw new Error('Entity must have an ID'); }
    return this.running.get(action.display)?.has(entity.id) ?? false;
  }
}
